import React, { useEffect } from 'react';
import Image from 'next/image';
import { SetStateAction, useState } from 'react';
import { deleteFromS3 } from '../../utils/s3';
import { ImageWithPreview as MediaImageWithPreview } from '../../shared-components/MediaUploader/MediaUploader';

import CitySelect from './CitySelect';
import CityTours from './CityTours';
import { useLazyQuery } from '@apollo/client';
import { CITIES_PRODUCT_FILTER } from '../../api/reviews';
import DateSelect from './DateSelect';
import ReviewForm from './ReviewForm';
import { useMediaQuery } from '../../layouts/Navbar/NavBar';
import { MyErrorObject } from './Header';
interface IProps {
  dispModal: boolean;
  setDispModal: React.Dispatch<SetStateAction<boolean>>;
  citiesPageDropDown: Record<string, any>[] | undefined;
  citiesDropDown: Record<string, any>;
  handleRating: (rate: number) => void;
  rating: number;
  setRating: React.Dispatch<SetStateAction<number>>;
  errorObject: MyErrorObject;
  setErrorObject: React.Dispatch<SetStateAction<MyErrorObject>>;
  setRefetch: React.Dispatch<SetStateAction<boolean>>;
}

const AddReview = ({
  dispModal,
  setDispModal,
  citiesPageDropDown,
  citiesDropDown,
  handleRating,
  rating,
  setRating,
  errorObject,
  setErrorObject,
  setRefetch
}: IProps) => {
  const [submitReview, setSubmitReview] = useState<Record<string, unknown>>({
    source: null
  });
  const [termsConditions, setTermsConditions] = useState<boolean>(false);
  const [reviewSubmitting, setReviewSubmitting] = useState(false);
  const [images, setImages] = useState<MediaImageWithPreview[]>([]);
  const [errorStates, setErrorStates] = useState<Record<string, boolean>>({
    date: true,
    traveller: true,
    review: true,
    city: true,
    product: false
  });

  const [selectedCity, setSelectedCity] = useState<string | null>(null);
  const [selectedCityProduct, setSelectedCityProduct] = useState<string | null>(
    null
  );
  const [dispCalendar, setDispCalendar] = useState<boolean>(false);
  const [cityDropdownToggle, setCityDropdownToggle] = useState<boolean>(false);
  const [tourDropdownToggle, setTourDropdownToggle] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<any>();
  const mediaQuery = useMediaQuery(640);
  const [fetchCityTours, { data: { cities } = [] }] = useLazyQuery(
    CITIES_PRODUCT_FILTER
  );

  const onModalClose = async () => {
    if (!reviewSubmitting && images?.length > 0) {
      const uploadedFiles = images?.filter(img => img?.uploadedUrl);
      if (uploadedFiles?.length > 0) {
        for (const img of uploadedFiles) {
          if (img?.uploadedUrl) {
            await deleteFromS3(img?.uploadedUrl);
          }
        }
      }
    }
    setDispModal(false);
  };

  useEffect(() => {
    fetchCityTours({
      variables: {
        filter: {
          name: selectedCity
        }
      }
    });
  }, [selectedCity]);
  useEffect(() => {
    setSelectedCityProduct('');
    setSubmitReview(prevState => {
      return {
        ...submitReview,
        product: ''
      };
    });
  }, [selectedCity]);
  {
    /* Modal Wrapper z-index should be 1150 or in between 1100 and 1200 */
  }

  return (
    <div
      id="review-modal-wrapper"
      className="w-[100%] h-[100vh] fixed top-0 left-0 z-[1150] bg-modalWrapper flex justify-center items-center"
      onClick={onModalClose}
    >
      <div
        id="review-modal"
        className=" bg-[#FFFFFF] w-[88%] sm:w-[70%] lg:w-[50%] xl:w-[40%] absolute top-[8%]"
        onClick={e => {
          e.stopPropagation();
          setDispCalendar(false);
        }}
      >
        <div
          className="hover:cursor-pointer w-6 ml-auto mr-3 mt-2"
          onClick={onModalClose}
        >
          <Image
            src="https://res.cloudinary.com/see-sight-tours/image/upload/v1685544129/Remaining%20images/Reviews/radix-icons_cross-2_mlrxew.svg"
            width={mediaQuery ? 20 : 30}
            height={mediaQuery ? 20 : 30}
            alt="cross-button"
          />
        </div>
        <div className="px-4 md:px-8 pb-5 max-h-[70vh] xsm:max-h-[75vh] 2xl:max-h-[80vh] overflow-auto">
          <h2 className="text-[18px] md:text-[22px] lg:text[28px] xl:text-[36px] font-bold">
            Share your experience with us
          </h2>
          <p className="text-[15px] xl:text-[18px] text-[#555555] mt-1">
            Your feedback helps us make our tours better for everyone.
          </p>
          {/* @ts-ignore */}
          <div
            className={`flex flex-col ${
              reviewSubmitting ? 'pointer-events-none' : ''
            }`}
          >
            <DateSelect
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              dispCalendar={dispCalendar}
              setDispCalendar={setDispCalendar}
              submitReview={submitReview}
              setSubmitReview={setSubmitReview}
              errorStates={errorStates}
              setErrorStates={setErrorStates}
              errorObject={errorObject}
              setErrorObject={setErrorObject}
              cityDropdownToggle={cityDropdownToggle}
              setCityDropdownToggle={setCityDropdownToggle}
              tourDropdownToggle={tourDropdownToggle}
              setTourDropdownToggle={setTourDropdownToggle}
            />
            {errorObject?.date && (
              <div className="text-red-400 text-[10px] sm:text-[14px] lg-text-[18px]">
                {errorObject?.date}
              </div>
            )}
            <CitySelect
              citiesDropDown={citiesDropDown}
              selectedCity={selectedCity}
              setSelectedCity={setSelectedCity}
              cityDropdownToggle={cityDropdownToggle}
              setCityDropdownToggle={setCityDropdownToggle}
              tourDropdownToggle={tourDropdownToggle}
              setTourDropdownToggle={setTourDropdownToggle}
              submitReview={submitReview}
              setSubmitReview={setSubmitReview}
              errorStates={errorStates}
              setErrorStates={setErrorStates}
              errorObject={errorObject}
              setErrorObject={setErrorObject}
            />
            {errorObject?.cities && (
              <div className="text-red-400 text-[10px] sm:text-[14px] lg-text-[18px]">
                {/* @ts-ignore */}
                {errorObject?.cities}
              </div>
            )}
            {selectedCity && (
              <CityTours
                cities={cities}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                selectedCityProduct={selectedCityProduct}
                setSelectedCityProduct={setSelectedCityProduct}
                cityDropdownToggle={cityDropdownToggle}
                setCityDropdownToggle={setCityDropdownToggle}
                tourDropdownToggle={tourDropdownToggle}
                setTourDropdownToggle={setTourDropdownToggle}
                submitReview={submitReview}
                setSubmitReview={setSubmitReview}
                errorStates={errorStates}
                setErrorStates={setErrorStates}
                errorObject={errorObject}
                setErrorObject={setErrorObject}
              />
            )}

            <ReviewForm
              rating={rating}
              submitReview={submitReview}
              setSubmitReview={setSubmitReview}
              handleRating={handleRating}
              termsConditions={termsConditions}
              setTermsConditions={setTermsConditions}
              errorStates={errorStates}
              setErrorStates={setErrorStates}
              errorObject={errorObject}
              setErrorObject={setErrorObject}
              setDispModal={setDispModal}
              setRefetch={setRefetch}
              setReviewSubmitting={setReviewSubmitting}
              images={images}
              setImages={setImages}
              onReviewSubmitted={() => {
                setDispModal(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddReview;
